import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { AccountAppValue, RewardLockupType, RewardStateFilterType } from "@fabric-types/app-account";
import { Store } from "@ngrx/store";
import { CommonState } from "@obg/ngx.common";
import { CoreState } from "@obg/ngx.core";
import { TranslationSelector } from "@obg/ngx.core.content";
import { DocumentRef } from "@obg/ngx.global.evo";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
	selector: "obg-m-ticket-counter",
	templateUrl: "./ticket-counter.component.html",
	styleUrls: ["./ticket-counter.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class TicketCounterComponent implements OnInit {
	@HostBinding("class.obg-m-ticket-counter") hostCssClass = true;

	tokenRewardCount$: Observable<number> | undefined;

	url$ = this.store.pipe(this.translationSelector.getByKey$("common.ticketcounter-link"));

	constructor(
		private store: Store<CommonState | CoreState>,
		private translationSelector: TranslationSelector,
		private documentRef: DocumentRef
	) {}

	ngOnInit(): void {
		this.tokenRewardCount$ = new Observable(
			this.documentRef.obgEventBus.retrieve(AccountAppValue.GetRewardCount, {
				objectType: RewardLockupType.TokenReward,
				rewardStateFilterType: [RewardStateFilterType.Claimable],
			})
		).pipe(map((count) => count.claimable));
	}
}
